import { render } from "./PageStart.vue?vue&type=template&id=b93cd202&scoped=true"
import script from "./PageStart.vue?vue&type=script&lang=js"
export * from "./PageStart.vue?vue&type=script&lang=js"

import "./PageStart.vue?vue&type=style&index=0&id=b93cd202&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93cd202"]])

export default __exports__